import { Injectable } from "@angular/core";
import { FilterableFieldDynamicValue } from "src/shared/models/pipeline-config/reporting-sets.models";
import { CVApiService } from "../services/cv-api.service";

@Injectable({
    providedIn: "root",
})
export class ReportingSetDynamicFiltersService {
    constructor(private service: CVApiService) {}

    async loadReportFilters( reportingSetName: string, valueDisplayField: string, valueField: string): Promise<FilterableFieldDynamicValue[]> {
        const url = `/api/v2/pipeline/report-filters/${reportingSetName}/${valueDisplayField}/${valueField}`;
        try {
            const response = await this.service.get<FilterableFieldDynamicValue[]>(url);

            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            } 
			else {
				throw response;
            }
        } 
		catch (error) {
            console.error("Failed getting report filters");
            throw error;
        }
    }
}
